import "./AccountForm.less";

import React, { Component } from "react";
import { translate } from "react-i18next";
import $ from "jquery";
import queryString from "query-string";

import { CreateAccountContext } from "../../../contexts/contexts";
import { Navigator } from "../Navigator/Navigator";
import Password from "../../Password/Password";

import config from "../../../config";

const STUDENT = "student"; // TODO: Import from RoleSelect.js

class AccountForm extends Component {
	static contextType = CreateAccountContext;

	state = {
		email: "",
		password: "",
		mailAlreadyTaken: false,
	};

	render() {
		const t = this.props.t;

		return (
			<div className="account-form">
				<Navigator onBackClick={this.handleNavigatorBackClick} />

				<form onSubmit={this.registerClickHandler}>
					<input type="text" placeholder={t("givenNamePlaceholder")} value={this.state.givenName} onChange={e => this.setState({givenName: e.target.value})} />
					<input type="text" placeholder={t("surNamePlaceholder")} value={this.state.surName} onChange={e => this.setState({surName: e.target.value})} />
					<input type="email" placeholder={t("emailPlaceholder")} value={this.state.email} onChange={this.handleEmailChange} />
					{
						this.isEmailAlreadyTaken() &&
						<div className="error-holder">
							<p className="error">{t("emailError")}</p>
							<div className="instruction">
								<p>{t("emailInstructionQuestion")}</p>
								<a href="/login">{t("emailInstructionSolution")}</a>
							</div>
						</div>
					}
					<Password onChange={this.handlePasswordChange} />
					{this.state.showError && <p className="error">{this.state.errorMessage}</p>}
					<button type="submit" className="primarybtn">
						{t("register")}
					</button>
				</form>

				{this.context.role === STUDENT && <div>
					<div className="separator">
						<hr />
						<p>{t("alternativeRegister")}</p>
					</div>

					<div className="register-button-container">
						<button className="primarybtn regbtn smartschool" onClick={this.registerWithSmartschoolClickHandler}>Smartschool</button>
					</div>
				</div>}
			</div>
		);
	}

	isEmailAlreadyTaken() {
		return this.state.mailAlreadyTaken;
	}

	handleEmailChange = event => {
		this.setState({ email: event.target.value });
	};

	handlePasswordChange = password => {
		this.setState({ password });
	};

	handleNavigatorBackClick = () => {
		this.context.setInstitution();
		
		if (this.context.role === STUDENT) {
			this.context.setRole();
			this.props.goToStep(1);
		} else {
			this.props.previousStep();
		}
	};
	

	registerClickHandler = e => {
		const t = this.props.t;

		e.preventDefault();

		if ((this.state.givenName || '').trim().length === 0) {
			this.setState({ showError: true, errorMessage: t('givenNameRequired'), mailAlreadyTaken: false });
			return;
		}

		if ((this.state.surName || '').trim().length === 0) {
			this.setState({ showError: true, errorMessage: t('surNameRequired'), mailAlreadyTaken: false });
			return;
		}

		if ((this.state.email || '').trim().length === 0) {
			this.setState({ showError: true, errorMessage: t('emailAddressRequired'), mailAlreadyTaken: false });
			return;
		}

		if ((this.state.password || '').trim().length === 0) {
			this.setState({ showError: true, errorMessage: t('passwordRequired'), mailAlreadyTaken: false });
			return;
		}
		
		this.setState({ showError: false, errorMessage: '', mailAlreadyTaken: false });
		
		const currentQuery = queryString.parse(window.location.search);
		const returnUrl = currentQuery.returnUrl;

		$.post(`${config.identityServer.baseUrl}/Portal/Register`, {
			username: this.state.email,
			password: this.state.password,
			givenName: this.state.givenName,
			surName: this.state.surName,
			clientId: currentQuery.clientId || config.identityServer.clientId,
			culture: config.language + "-BE",
			isStudent: this.context.role === STUDENT,
			region: this.context.school.id,
			gradeLevel: this.context.role === STUDENT ? undefined : this.context.institution.id,
			returnUrl: returnUrl
		},
		result => {
			if (!result.success) {
				if (result.alreadyRegistered) {
					this.setState({ showError: false, errorMessage: '', mailAlreadyTaken: result.alreadyRegistered });
				}
				else {
					this.setState({ showError: true, errorMessage: t(result.errorCode), mailAlreadyTaken: false });
				}
			}
			else {
				this.props.nextStep();
			}
        })
		.fail(() => {
			this.setState({ showError: true, errorMessage: t('unexpectedError') });
		});
	}

	registerWithSmartschoolClickHandler = () => {		
		const currentQuery = queryString.parse(window.location.search);
		const returnUrl = currentQuery.returnUrl;
		const clientId = config.identityServer.clientId;
		const culture = config.language + "-BE";

		const query = queryString.stringify({ provider: "Smartschool", registerStudent: true, returnUrl, clientId, culture });
		window.location = `${config.identityServer.baseUrl}/Portal/LogInExternal?${query}`;
	}
}

export default translate("accountForm")(AccountForm);



// WEBPACK FOOTER //
// ./src/components/CreateAccount/AccountForm/AccountForm.js